import { render, staticRenderFns } from "./ChangeAssignee.vue?vue&type=template&id=00318cec&"
import script from "./ChangeAssignee.vue?vue&type=script&lang=js&"
export * from "./ChangeAssignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports